import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, Injector, NgModule } from '@angular/core';
import { HttpModule, Http, XSRFStrategy } from '@angular/http';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AppSettingsService } from './shared/app-settings/app-settings.service';
import { setSettingsProvider } from './settings.prefetch';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { BASE_PATH } from './api/variables';
import { TitleService } from './title.service';
import { CustomHttpService } from './custom-http.service';
import { PagePreloaderService } from './page-preloader.service';
import { XSRFProvider } from './xsrf.provider';
import { NotificationsService } from 'angular2-notifications';
import { RavenErrorHandler } from './raven.provider';
import {
  MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateParser,
  TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from './translates/loader.service';
import { MyMissingTranslationHandler } from './translates/missing.service';
import { MyTranslateParser } from './translates/parser.service';
import { BillingApi } from './api/api/BillingApi';
import { ChannelsApi } from './api/api/ChannelsApi';
import { EditorApi } from './api/api/EditorApi';
import { EventsApi } from './api/api/EventsApi';
import { FeedbackApi } from './api/api/FeedbackApi';
import { LandingsApi } from './api/api/LandingsApi';
import { PagesApi } from './api/api/PagesApi';
import { PartnersApi } from './api/api/PartnersApi';
import { ServicesApi } from './api/api/ServicesApi';
import { SettingsApi } from './api/api/SettingsApi';
import { VideolessonsApi } from './api/api/VideolessonsApi';
import {DevAuthInterceptor} from './core/interceptors/dev-auth.interceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';

const routes: Routes = [
  {
    path: 'partners',
    loadChildren: './partners/partners.module#PartnersModule'
  }, {
    path: 'services',
    loadChildren: './services/services.module#ServicesModule'
  }, {
    path: 'channels',
    loadChildren: './channels/channels.module#ChannelsModule'
  }, {
    path: '404',
    loadChildren: './page-not-found/page-not-found.module#PageNotFoundModule'
  }, {
    path: '**',
    redirectTo: '/404'
  }
];

const providers: any[] = [
  BillingApi,
  ChannelsApi,
  EditorApi,
  EventsApi,
  FeedbackApi,
  LandingsApi,
  PagesApi,
  PartnersApi,
  ServicesApi,
  SettingsApi,
  VideolessonsApi,
  TitleService,
  PagePreloaderService,
  NotificationsService,
  {
    provide: APP_INITIALIZER,
    useFactory: setSettingsProvider,
    deps: [SettingsApi, AppSettingsService, TranslateService],
    multi: true
  }, {
    provide: BASE_PATH,
    useValue: environment.apiEndpoint
  }, {
    provide: Http,
    useClass: CustomHttpService
  }, {
    provide: XSRFStrategy,
    useFactory: XSRFProvider
  }, {
    provide: TranslateLoader,
    useClass: TranslateHttpLoader,
    deps: [Injector]
  }
];

// if (environment.production) {
//   providers.push({
//     provide: ErrorHandler,
//     useClass: RavenErrorHandler
//   });
// }

if (!environment.production) {
  providers.push(
      {provide: HTTP_INTERCEPTORS, useClass: DevAuthInterceptor, multi: true},
  );
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    RouterModule.forRoot(routes),
    CoreModule,
    SharedModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forRoot({
      parser: {
        provide: TranslateParser,
        useClass: MyTranslateParser,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
      }
    })
  ],
  providers: providers,
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/app.module.ts